import { Component, Input } from '@angular/core';
import { Client } from 'src/app/feature/BNPL/shared/models/client.model';
import { FirstStep } from 'src/app/feature/BNPL/shared/models/first-step.model';
import { Payment } from 'src/app/feature/BNPL/shared/models/payment.model';
import { BnplService } from 'src/app/feature/BNPL/shared/services/bnpl.service';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css'],
})
export class VoucherComponent {
  @Input() brand: Client | null = null;
  @Input() details: Payment | null = null;

  public clientInfo: FirstStep = this.bnplService.stepsInformation.firstStep;
  public image: string =
    'https://image-bnpl.s3.amazonaws.com/banner-approbe.png';

  constructor(private bnplService: BnplService) {}

  ngAfterViewInit() {
    setTimeout(() => {
      window.print();
    }, 500);
  }
}
